<template>
  <div class="complain">
    <van-overlay :show="show" @click="show = false">
      <div class="phone_box">
        <div class="box_head">
          <div class="head_title">请拨打投诉对象所属园区电话</div>
          <div class="head_close">
            <img src="../../assets/img/icon_close.png" alt="" />
          </div>
        </div>
        <div v-for="(item, index) in phoneList" :key="index" @click.stop="callPhone(item)">
          <div class="box_item" v-if="item.telNo">
            <div class="address">
              {{ item.scenicName }} <span>{{ `(${item.telNo})` }}</span>
            </div>
            <div class="item_icon" v-if="item.scenicName == scenicName">
              <img src="../../assets/img/compale_icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

    <div class="content">
      <div class="map">
        <div id="container"></div>
        <div class="my-complain" @click="myComplain()">
          <van-image :src="myComplainIcon" width="12px" height="12px"></van-image>
          <span>我的投诉</span>
        </div>
      </div>
      <div class="top">
        <van-image :src="timeIcon" width="20" height="20"> </van-image>
        投诉受理时间：08:30~18:30
      </div>
      <div class="type">
        <div class="online type-item" @click="goComplain()">
          <van-image :src="onlineIcon" width="38" height="38"> </van-image>
          <p>在线投诉</p>
        </div>
        <div class="phone type-item" @click="goCall()">
          <a v-show="noGreen">
            <van-image :src="offlineIcon" width="38" height="38"> </van-image>
          </a>
          <a v-show="!noGreen">
            <van-image :src="offlineIcon" width="38" height="38"> </van-image>
          </a>
          <p>电话投诉</p>
        </div>
      </div>
      <div class="site">
        <van-image :src="siteIcon" width="11px" height="11px"></van-image>
        <span class="address">{{ address }}</span>
      </div>
      <div class="exa-list">
        <p>常见问题</p>
        <ul>
          <li class="list-item" v-for="(item, index) in quesList" :data-type="0" :key="index">
            <div class="wrap">
              <div class="exa-title">{{ item.content }}</div>
              <div class="exa-aply" @click="goComplaindetail(item)">
                去投诉
                <van-icon name="arrow" slot="right" />
              </div>
            </div>
          </li>
          <!--          <li>-->
          <!--            <div class="wrap">-->
          <!--              <div class="exa-title">购物强制消费</div>-->
          <!--              <div class="exa-aply">-->
          <!--                去投诉-->
          <!--                <van-icon-->
          <!--                        name="arrow"-->
          <!--                        slot="right"-->
          <!--                />-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </li>-->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { Dialog } from "vant";
import axios from "axios";
const QQMap = window.qq.maps;
export default {
  data() {
    return {
      noGreen: true,
      siteIcon: require("../../assets/iconImage/ic_20_location@2x.png"),
      address: "",
      timeIcon: require("../../assets/iconImage/time.png"), // 位置图标
      onlineIcon: require("../../assets/iconImage/complainonline.png"), // 位置图标
      offlineIcon: require("../../assets/iconImage/complainoffline.png"), // 位置图标
      quesList: [],
      state: "abc123", // 微信授权状态码
      myComplainIcon: require("../../assets/iconImage/ic_complain@3x.png"),
      show: false,
      phoneList: [],
      scenicName: "",
    };
  },
  created() {
    //localStorage.setItem('mobile','13812025534')
    this.scenicName = this.$route.query.scenicName;
    this.getQueslist();
    this.getUserInfo();
    // if (this.$cookie.get('w_uid') !== '') {
    //   // if (this.$cookie.get('w_uid') == 0) {
    //   //   this.$router.replace({
    //   //     name: 'bindingPhone'
    //   //   })
    //   // } else {
    //   //   this.wxAuth();
    //   // }
    // }
  },
  mounted() {
    document.title = "投诉";
    let lat = sessionStorage.getItem("dislLat") || "";
    let lng = sessionStorage.getItem("dislLng") || "";
    this.getAddress(lat, lng).then((res) => {
      console.log(res);
      if (res) {
        this.address = res.address;
        this.init(lat, lng);
      } else {
        this.address = "定位服务未开启";
        lat = 30.5632594;
        lng = 104.0677888;
        this.init(lat, lng, true);
      }
    });
  },
  methods: {
    /**
     * 打点话
     */
    callPhone(item) {
      if (item.telNo) {
        window.location.href = `tel:${item.telNo}`;
      }
    },

    getAddress(lat, lng) {
      return new Promise((resolve, reject) => {
        $.ajax({
          type: "get",
          url: "https://apis.map.qq.com/ws/geocoder/v1/",
          dataType: "jsonp",
          data: {
            key: "LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG", //开发密钥
            location: `${lat},${lng}`, //位置坐标
            get_poi: "0", //是否返回周边POI列表：1.返回；0不返回(默认)
            coord_type: "1", //输入的locations的坐标类型,1 GPS坐标
            output: "jsonp",
          },
          success: (data) => {
            resolve(data.result);
          },
        });
      });
    },
    // 返回首页
    Back() {
      this.$router.push({
        path: "/",
      });
      //this.$router.go(-1);
    },
    // 微信授权
    // wxAuth() {
    //   /* eslint-disable */
    //   window.location.href = `${
    //     this.urlHost
    //     }/appserver/v1/user/authorize?redirect_uri=${encodeURIComponent(
    //       window.location.href
    //     )}&state=${this.state}`;
    // },
    // 获取用户信息
    getUserInfo() {
      let open_id = this.$cookie.get("w_open_id");
      let skey = this.$cookie.get("w_skey");
      let uid = this.$cookie.get("w_uid");
      this.$request
        .post(
          `/appserver/v1/user/get_auth_data?open_id=${open_id}&skey=${skey}&uid=${uid}`
        )
        .then((data) => {
          console.log(data.data.data);

          if (data.data.ret == 0) {
            // 把用户信息存到localStorage
            // localStorage.setItem('uid', this.user.uid);
            localStorage.setItem("userName", data.data.data.nickname);
            localStorage.setItem("userImg", data.data.data.userImg);
            localStorage.setItem("mobile", data.data.data.mobile);
            // console.log(window.location.href.includes("state=wxAuth2"), "href");
            // 如果手机号为空，跳转绑定手机号页面
            if (!data.data.data.mobile) {
              this.$router.replace({
                name: "bindingPhone",
              });
            }
          } else {
            if (uid == 0 && window.location.href.includes("state=wxAuth2")) {
              this.$router.replace({
                name: "bindingPhone",
              });
            } else {
              this.wxAuth("wxAuth2");
            }
          }
        });
    },

    // 地图
    init(lat, lng, isHideMarker) {
      /* eslint-disable */
      // 设置地图中心点
      var myLatlng = new qq.maps.LatLng(lat, lng);
      // var myLatlng = new qq.maps.LatLng(30.56263,104.06255);
      // 定义工厂模式函数
      var myOptions = {
        zoom: 13, // 设置地图缩放级别
        center: myLatlng, // 设置中心点样式
        zoomControl: false,
        disableDefaultUI: true,
        mapTypeId: qq.maps.MapTypeId.ROADMAP, // 设置地图样式详情参见MapType
      };
      // 获取dom元素添加地图信息
      var map = new qq.maps.Map(
        document.getElementById("container"),
        myOptions
      );
      var cssC = {
        height: "20px",
        top: "300px",
        left: "150px",
        color: "#2EBA73",
        fontSize: "12px",
        borderRadius: "20px",
        borderColor: "#2EBA73",
        textAlign: "center",
        lineHeight: "20px",
        // marginLeft: '-45px',
        transform: "translateX(-40%)",
        marginTop: "-30px",
        overflow: "hidden",
        padding: "0 5px",
      };
      var label = new qq.maps.Label({
        position: myLatlng,
        map: map,
        style: cssC,
        content: this.address,
      });
      let centerMarker = new QQMap.Marker({
        position: new QQMap.LatLng(lat, lng),
        map: map,
      });

      let centerIcon = require("../../assets/img/location_icon.png");
      let centerSize = new QQMap.Size(21, 22);
      let centerOrigin = new QQMap.Point(0, 0);
      let centerAnchor = new QQMap.Point(0, 0);
      let centerScaleSize = new QQMap.Size(21, 22);
      let cetnerImage = new QQMap.MarkerImage(
        centerIcon,
        centerSize,
        centerOrigin,
        centerAnchor,
        centerScaleSize
      );
      centerMarker.setIcon(cetnerImage);
      if (isHideMarker) {
        label.setVisible(false);
        centerMarker.setVisible(false);
      } else {
        label.setVisible(true);
        centerMarker.setVisible(true);
      }
    },
    getQueslist() {
      this.$request
        .get(`/appserver/v1/complaint/complainProblem`)
        .then((data) => {
          this.quesList = data.data.data;
        });
    },
    goComplain() {
      if (
        this.$cookie.get("w_open_id") == "" ||
        this.$cookie.get("w_open_id") == null
      ) {
        this.$toast("请授权");
        this.wxAuth();
      } else {
        //判断用户是否登录
        if (
          localStorage.getItem("mobile") === "" ||
          localStorage.getItem("mobile") === "undefined" ||
          localStorage.getItem("mobile") === null
        ) {
          this.$router.push({ path: "/bindingPhone" });
        } else {
          this.$router.push({
            path: "/complainSubmit",
            query: {
              item: "",
              greenwayIn: this.$route.query.greenwayIn,
              scenicId: this.$route.query.scenicId,
            },
          });
        }
      }
    },
    goComplaindetail(item) {
      if (
        this.$cookie.get("w_open_id") == "" ||
        this.$cookie.get("w_open_id") == null
      ) {
        this.$toast("请授权");
        this.wxAuth();
      } else {
        //判断用户是否登录
        if (
          localStorage.getItem("mobile") === "" ||
          localStorage.getItem("mobile") === "undefined" ||
          localStorage.getItem("mobile") === null
        ) {
          this.$router.push({ path: "/bindingPhone" });
        } else {
          this.$router.push({
            path: "/complainSubmit",
            query: {
              item: item,
              greenwayIn: this.$route.query.greenwayIn,
              scenicId: this.$route.query.scenicId,
            },
          });
        }
      }
    },

    goCall() {
      if (this.phoneList.length > 0) {
        this.show = true;
        return;
      }
      // if (this.$route.query.greenwayIn == 2) {
      // 亚运说的 不再判断
      if (false) {
        this.noGreen = true;
        // this.$toast('');
        Dialog.confirm({
          title: "电话投诉",
          message: "您不在园区内，无法电话投诉",
          showCancelButton: false,
          confirmButtonText: "确认",
          confirmButtonColor: "#2EBA73",
        })
          .then(() => { })
          .catch(() => {
            console.log("cancel");
          });
      } else {
        this.noGreen = false;

        // console.log(this.$route.query.greenWayId);
        axios
          .create({
            baseURL: this.newUrlHost,
            headers: {},
            withCredentials: true,
          })
          .get("/appserver/v1/complaint/getComplaintTelAll")
          .then((data) => {
            console.log(data, "data");
            if (data.data.ret === 0) {
              if (data.data.data === null) {
                this.$toast({
                  message: data.data.msg,
                  duration: "5000",
                });
              } else {
                console.log("电话投诉");
                console.log(data.data.data, "data.data.data");
                if (this.$route.query.greenwayIn == 1) {
                  // 在景区
                  let tel = "";
                  let phoneList = data.data.data;
                  for (let i in phoneList) {
                    if (phoneList[i].scenicName == this.$route.query.scenicName) {
                      tel = phoneList[i].telNo;
                    }
                  }
                  if (tel) {
                    Dialog.confirm({
                      title: "电话投诉",
                      message: tel,
                      showCancelButton: true,
                      confirmButtonText: "拨号",
                      confirmButtonColor: "#2EBA73",
                    })
                      .then(() => {
                        window.location.href = "tel:" + tel;
                      })
                      .catch(() => {
                        console.log("cancel");
                      });
                  } else {
                    this.$toast({
                      message: "该园区暂未提供电话求助服务",
                      duration: "5000",
                    });
                  }

                } else {
                  // 不在景区
                  this.phoneList = data.data.data;
                  this.show = true;
                }
              }
            } else {
              this.$toast({
                message: "该园区暂未提供电话求助服务",
                duration: "5000",
              });
            }
          });
      }
    },
    myComplain() {
      this.$router.push({
        path: "/myComplain",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.complain {
  font-size: 14px;

  .phone_box {
    width: 100%;
    max-height: 360px;
    background: #ffffff;
    border-radius: 8px 8px 0px 0px;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    .box_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 15px;
      .head_title {
        font-size: 16px;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #222222;
      }
      .head_close {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .box_item {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 1px solid #e8e8e8;
      .address {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555959;
      }
      .item_icon {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      &:last-child {
        border: 0;
      }
    }
  }

  .title {
    .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
    }

    .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
      font-weight: 600;
    }
  }
  .content {
    .top {
      text-align: center;
      color: #2eba73;
      // border-bottom: 10px solid #f8f8f8;
      padding-top: 20px;
      // padding-bottom: 25px;
      display: flex;
      justify-content: center;
      .van-image {
        margin-right: 10px;
      }
    }
    .map {
      width: 100%;
      position: relative;
      #container {
        width: 100%;
        height: 200px;
        .csssprite {
          background: #fff;
          color: #2eba73;
          border-radius: 5%;
        }
      }
      .my-complain {
        position: absolute;
        top: 14px;
        right: 0px;
        width: 90px;
        height: 30px;
        line-height: 30px;
        background: #2eba73;
        // z-index: 1200;
        border-bottom-left-radius: 20px;
        border-top-left-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        span {
          font-size: 13px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          margin-left: 4px;
        }
      }
    }
    .type {
      display: flex;

      margin: 10px 30px;
      // border-bottom: 1px solid #ddd;
      padding-bottom: 10px;
      margin-top: 30px;
      .online {
        flex: 1;
        flex: 1;
        justify-content: center;
        text-align: center;
      }
      .phone {
        flex: 1;
        flex: 1;
        justify-content: center;
        text-align: center;
      }
      .type-item {
        color: #262626;
        p {
          margin-top: 10px;
        }
        /deep/ .van-image {
          img {
            background-color: #e1f1ea;
            border-radius: 45%;
          }
        }
      }
    }

    .site {
      width: 80%;
      background-color: #f2f2f2;
      padding: 10px 15px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // border-bottom: 10px solid #f8f8f8;
      margin: 0 auto;
      margin-top: 10px;
      border-radius: 3px;
      & > span {
        margin-left: 6px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }
    .exa-list {
      margin: 20px;
      margin-top: 45px;
      p {
        color: #37384d;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 13px;
        border-bottom: 1px solid #e8e8e8;
      }
      li {
        border-bottom: 1px solid #f4f4f4;
        padding-bottom: 20px;
        padding-top: 20px;
        color: #838686;
      }
      .list-item {
        .exa-title {
          color: #262626;
        }
      }
    }
    .wrap {
      display: flex;
      .exa-aply {
        flex: 1;
        display: flex;
        color: #9c9c9c;
        justify-content: flex-end;
        position: relative;
        padding-right: 28px;
        align-items: center;
        i {
          position: absolute;
          bottom: 0;
          font-size: 20px;
          right: 0;
        }
      }
    }
  }
}
</style>
